import { type PropsWithChildren } from "react";

import { Footer } from "@vega-core/components/Layout/Footer/Footer";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";

import { AuthHeader } from "../../../Auth/components/AuthHeader";
import { getLPLoginFaqItems } from "../../Login/lpLoginFaq";
import { useCmsLoginFaqs } from "../../Login/useCmsLoginFaqs";

import { Banner } from "./Banner";

export const RegistrationLayout = ({ children }: PropsWithChildren) => {
  const {
    contacts: { helpEmail },
    global: { companyName },
  } = usePublicConfig();
  const faqItems = useCmsLoginFaqs(getLPLoginFaqItems(helpEmail, companyName));

  return (
    <div className="min-h-dvh p-4 lg:p-13 flex gap-13 bg-background/primary">
      <div className="w-full lg:w-1/2 flex flex-col bg-background/primary">
        <AuthHeader faqItems={faqItems} />
        <div className="flex flex-grow w-full flex-col justify-center p-1 align-center items-center">
          <div className="max-w-xl">{children}</div>
        </div>
        <Footer containerStyle="p-0" isLoggedIn={false} />
      </div>

      <div className="hidden lg:flex flex-1 justify-center items-center bg-background/auth/secondary rounded">
        <Banner />
      </div>
    </div>
  );
};
